<template>
    <v-field :label="label">
        <q-input-frame :color="color">
            <q-icon name="info" size="2.2em" :color="this.value.length ? 'red' : 'highlight'" />
        </q-input-frame>
    </v-field>
</template>

<script>
import mixins from './mixins'
import {
    QInputFrame
} from 'quasar-framework'

export default {
    name: 'VMinimumStockAlert',
    components: { QInputFrame },
    mixins,

    props: {
        color: {
            type: String,
            default: 'highlight'
        }
    },

    computed() {
        this.color = this.form['kits_available'] ? 'red' : 'highlight'
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/form/VMinimumStockAlert.vue